<template>
  <div class="upload_image_div">
    <template v-if="disabled">
      <div class="disabled_pic">
        <img :src="fileSrc" v-if="fileSrc" />
        <div v-else class="empty_div">
          <Icon type="md-add" :size="24" />
          <span>upload pictures</span>
        </div>
      </div>
    </template>
    <template v-else>
      <img :src="fileSrc" v-if="fileSrc" />
      <div v-else class="empty_div">
        <input class="upload_file" type="file" @change="fileChange" />
        <Icon type="md-add" :size="24" />
        <span>upload pictures</span>
      </div>
      <div class="delete_div" v-if="fileSrc">
        <Icon
          @click="deleteFileFun"
          type="ios-trash-outline"
          :size="26"
          color="#ed4014"
        />
      </div>
    </template>
    <Modal v-model="sureDeleteModel" title="Reminder" @on-ok="deleteFileOK">
      Are you sure delete ?
    </Modal>
  </div>
</template>
<script>
// import SYS_FUNCTIONS from "@/tools/tools";

export default {
  data() {
    return {
      sureDeleteModel: false,
      fileLoading: false,
      file: null,
      fileName: "",
      firstName: "",
      fileSrc: "",
      fileKey: "",
      isDisabled: false,
    };
  },
  props: {
    defalutImage: String,
    disabled: Boolean,
    limitSize: Number,
  },
  methods: {
    init() {},
    deleteFileFun() {
      this.sureDeleteModel = true;
    },
    deleteFileOK() {
      this.fileSrc = "";
      this.$emit("deleteImageKey", this.fileKey);
      window.AWS_S3_FUNCTIONS.DELETE_FILE(this.fileKey)
        .then((res) => {
          // console.log(res);
          if (res.isSuccess) {
            this.fileSrc = "";
            this.$Message.success("Deleted Successfully");
            this.$emit("deleteImageKey", this.fileKey);
          } else {
            this.$Notice.error({
              title: "Error",
              desc: res.data.Message,
              duration: 25,
            });
          }
        })
        .catch((e) => {
          this.$Message.error(e.err.message);
          // console.log(e);
        });
    },
    getTimeFun() {
      const d = new Date();
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();
      const h = d.getHours();
      const m = d.getMinutes();
      const s = d.getSeconds();
      return `${year}_${month}_${day}_${h}:${m}:${s}`;
    },
    /* 上传文件start */
    fileChange(e) {
      // console.log(e);
      const [file] = e.target.files;
      this.fileLoading = true;
      this.file = file;
      const { name } = this.file;
      this.fileName = name;
      this.firstName = name.substring(0, name.lastIndexOf("."));
      const last = name.substring(name.lastIndexOf(".") + 1);
      const arr = ["jpg", "png", "gif", "jpeg"];
      if (arr.includes(last)) {
        // return;
        this.uploadFileFun();
      } else {
        this.$Message.error("Please upload the image file.");
        this.fileLoading = false;
      }
    },
    uploadFileFun() {
      const num = window.parseInt(Math.random() * 10000);
      const imgKey = `APP_${this.firstName}_${this.getTimeFun()}_random_${num}`;
      // console.log(imgKey, "131321");
      // // console.log(this.file);
      if (this.limitSize) {
        if (this.file.size > this.limitSize * 1024 * 1024) {
          this.$Notice.error({
            title: "Error",
            desc: `Image size cannot exceed ${
              this.limitSize
            }M, Current picture ${parseFloat(
              this.file.size / 1024 / 1024
            ).toFixed(2)} M`,
            duration: 25,
          });
          return;
        }
      }
      window.AWS_S3_FUNCTIONS.UPLOAD_FILE_AWS_S3(imgKey, this.file)
        .then((res) => {
          // console.log(res);
          if (res.isSuccess) {
            this.fileLoading = false;
            this.fileKey = res.data.Key;
            this.$emit("uploadImageKey", this.fileKey);
            this.getFileFun();
            this.$Message.success("Upload Successfully");
          } else {
            this.$Message.error(`Error: ${res.err}`);
          }
        })
        .catch((e) => {
          // this.$Message.error(e.err.message);
          console.log(e);
        });
    },
    /* 上传文件end */
    getFileFun() {
      // console.log(this.fileKey);
      window.AWS_S3_FUNCTIONS.GET_IMG_FILE(this.fileKey)
        .then((res) => {
          // console.log(res);
          if (res.isSuccess) {
            this.fileSrc = res.data;
          } else {
            this.fileSrc = "";
          }
        })
        .catch((e) => {
          this.$Message.error(e.err.message);
          // console.log(e);
        });
    },
  },
  created() {
    this.init();
  },
  watch: {
    defalutImage(key) {
      // console.log(key);
      if (key) {
        this.fileKey = key;
        this.getFileFun();
      }
    },
  },
};
</script>
<style lang="less">
.upload_image_div {
  width: 100px;
  height: 100px;
  border: 1px dashed #ccc;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &:hover {
    border-color: #2d8cf0;
    .delete_div {
      display: flex;
    }
  }
  .empty_div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .upload_file {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }
  }
  .delete_div {
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    display: none;
  }
  .disabled_pic {
    cursor: not-allowed;
    height: 100%;
  }
}
</style>
